module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsBAMAAADsqkcyAAAAG1BMVEUAAAD////////////////////////////////rTT7CAAAACHRSTlMAzxPYGcS8Gr/QxykAAAA3SURBVCjPY6AHUE3AJsokIYBNWLG5AKtiE+yKHUYVE1DMEAFTTFgYYQimlaPKqaRcAFcmoRMAAJi/FSu12W9+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/common/images/icon_mall_navBar_arrow_Return.png
// module id = o9IZ
// module chunks = 6 12